import { createAction, createReducer } from '@reduxjs/toolkit'
import { reportError } from 'utils/reporting';
import { User, UserService, type UserSettings } from 'types';
import { Dispatch } from 'redux';
import { selectUser } from './selectors';
import { RootState } from '../reducer';

export type UserState = {
  userData: User | null,
}

const initialState: UserState = {
  userData: null,
};

export const setUserData = createAction<User | null>('USER/SET_USER_DATA');

export const loadUserData = (params: Parameters<typeof UserService.getCurrentUser>[0] = {}) => async (dispatch: Dispatch) => {
  try {
    const user = await UserService.getCurrentUser(params);
    dispatch(setUserData(user));
  } catch (err) {
    reportError(err);
  }
};

export const updateUserSettings = (settings: UserSettings) => async (dispatch: Dispatch, getState: () => RootState) => {
  const user = selectUser(getState());
  try {
    if (user) {
      const userData = await UserService.updateCurrentUser({
        requestBody: { settings: { ...user?.settings, ...settings } },
      });
      dispatch(setUserData(userData));
    }
  } catch (err) {
    reportError(err);
  }
};

export const userReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setUserData, (state, action) => {
      state.userData = action.payload;
    });
});
